/* ==========================================================================
   Mirabella — theme behaviour
   Plain JavaScript, no libraries. Everything degrades gracefully:
   if this file fails to load, the shop still works.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Some listeners sit on the document rather than on a section, so they
  // survive a section reload in the theme editor. Bind those only once.
  var documentBound = false;

  /* ------------------------------------------------------- Mobile menu */

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-open]');
    var menu = document.getElementById('mobile-menu');
    var close = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      document.body.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      var first = menu.querySelector('a, button');
      if (first) first.focus();
    }

    function shut() {
      menu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) shut();
    });
  }

  /* ---------------------------------------------------------- Search */

  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.getElementById('search-panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* --------------------------------------------------- Sticky header */

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;

    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        if (y > 8 !== last > 8) header.classList.toggle('is-stuck', y > 8);
        last = y;
      },
      { passive: true }
    );
  }

  /* -------------------------------------------------- Scroll reveals */

  function initReveals() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    // No animation wanted or possible? Leave the content plainly visible.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    // Only now do we hide things, so a failed script can't blank the page.
    document.documentElement.classList.add('reveal-ready');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) { io.observe(el); });

    // Failsafe. If the observer never reports back — a page opened in a
    // background tab, a prerender, an engine quirk — show everything
    // rather than leave the visitor staring at nothing.
    setTimeout(function () {
      if (!document.querySelector('.reveal.is-visible')) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
      }
    }, 1500);
  }

  /* ------------------------------------------------ Quantity steppers */

  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;

      var wrap = btn.closest('.qty');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = parseInt(input.value, 10) || min;
      value += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
      if (value < min) value = min;

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------ Quantity chooser

     The priced rows on the product page. The chosen row writes its
     number into the form's quantity field.

     The markup ships with the default row checked AND the quantity
     field already set to that same number, so if this never runs the
     form still submits the right quantity. This only handles changes. */

  function initBundle() {
    var bundle = document.querySelector('[data-bundle]');
    if (!bundle) return;

    var form = bundle.closest('form');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) return;

    bundle.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-bundle-qty]');
      if (!radio) return;

      qty.value = radio.value;
      qty.dispatchEvent(new Event('change', { bubbles: true }));

      var rows = bundle.querySelectorAll('.bundle__row');
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('is-selected', rows[i].contains(radio));
      }
    });
  }

  /* ------------------------------------------------- Product gallery */

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!full) return;

        main.src = full;
        main.alt = alt;
        main.removeAttribute('srcset');

        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ------------------------------------------------ Variant selection */

  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    var dataEl = document.getElementById('product-variants-json');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id]');
    // Price and buy buttons appear twice on phones: in the page and in the
    // sticky bar. Update every copy, not just the first.
    var priceEls = document.querySelectorAll('[data-variant-price]');
    var submits = document.querySelectorAll('[data-add-button]');
    var stockEl = document.querySelector('[data-variant-stock]');

    function selected() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function match(options) {
      return variants.find(function (v) {
        return options.every(function (opt, i) {
          return opt === null || v.options[i] === opt;
        });
      });
    }

    function update() {
      var variant = match(selected());

      if (!variant) {
        submits.forEach(function (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = btn.getAttribute('data-unavailable-text') || 'Unavailable';
        });
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (variant.price_html) {
        priceEls.forEach(function (el) { el.innerHTML = variant.price_html; });
      }

      submits.forEach(function (btn) {
        if (variant.available) {
          btn.removeAttribute('disabled');
          btn.textContent = btn.getAttribute('data-add-text') || 'Add to bag';
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = btn.getAttribute('data-sold-text') || 'Sold out';
        }
      });

      if (stockEl) {
        stockEl.textContent = variant.available
          ? stockEl.getAttribute('data-in-stock') || 'In stock, ready to ship'
          : stockEl.getAttribute('data-out-stock') || 'Currently out of stock';
        stockEl.classList.toggle('stock-note--out', !variant.available);
      }

      // Keep the address bar in step, so a shared link opens the right option.
      if (window.history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      // The quantity chooser uses radios inside this same form. Those are
      // not option buttons, so leave them to initBundle and ignore them here.
      if (e.target.closest('[data-bundle]')) return;
      if (e.target.matches('input[type="radio"]')) update();
    });

    update();
  }

  /* ------------------------------------------------------ Cart page */

  function initCart() {
    var root = document.querySelector('[data-cart]');
    if (!root) return;

    function change(line, quantity) {
      root.setAttribute('aria-busy', 'true');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      change(parseInt(input.getAttribute('data-cart-qty'), 10), qty);
    });
  }

  /* ------------------------------------------------- Sticky buy bar */

  // Slides up once the real Add to bag button has scrolled out of sight.
  // If the observer never reports, the bar simply stays hidden — the
  // page still has its own working buy button, so nothing is lost.
  function initBuyBar() {
    var bar = document.querySelector('[data-buy-bar]');
    var anchor = document.querySelector('.product__buy');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    ).observe(anchor);
  }

  /* -------------------------------------------------------- Marquee */

  // Duplicate the marquee content so the loop has no visible seam.
  function initMarquee() {
    document.querySelectorAll('.marquee__track').forEach(function (track) {
      if (track.children.length === 1) {
        track.appendChild(track.firstElementChild.cloneNode(true));
      }
    });
  }

  /* ------------------------------------------------ Social-proof card

     Two fixed messages, alternated on a timer. The markup ships with
     the first one already in place, so a page that never runs this
     script still shows a correct, non-empty card. */

  function initSocialProof() {
    var el = document.querySelector('[data-social-proof-text]');
    if (!el || el.dataset.socialProofBound) return;
    el.dataset.socialProofBound = 'true';

    var messages = [
      '🔥 18 people are viewing Bella right now',
      '🛍️ Someone in Cape Town ordered Bella recently'
    ];
    var index = 0;

    setInterval(function () {
      index = (index + 1) % messages.length;

      if (reduceMotion) {
        el.textContent = messages[index];
        return;
      }

      el.classList.add('is-fading');
      setTimeout(function () {
        el.textContent = messages[index];
        el.classList.remove('is-fading');
      }, 300);
    }, 4500);
  }


  /* ------------------------------------------------------ Video wall

     The clips are playable without this script: the source is in the
     markup and the native controls are on. What this adds is the muted
     autoplay while a card is on screen, and a working sound button.

     Sound rules: off until asked for, only one clip audible at a time,
     and leaving a card re-mutes it so sound cannot follow you down the
     page. */

  function initVideoWall() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('[data-vwall-video]'));
    if (!videos.length) return;

    function buttonFor(video) {
      return video.parentNode ? video.parentNode.querySelector('[data-vwall-sound]') : null;
    }

    function setLabel(btn, on) {
      if (!btn) return;
      var text = btn.querySelector('.vwall__sound-text');
      if (text && !btn.dataset.offText) btn.dataset.offText = text.textContent;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      if (text) {
        text.textContent = on
          ? (btn.getAttribute('data-on-text') || 'Sound on')
          : btn.dataset.offText;
      }
    }

    function mute(video) {
      video.muted = true;
      setLabel(buttonFor(video), false);
    }

    // Remember the off-state wording before anything changes it.
    videos.forEach(function (v) { setLabel(buttonFor(v), false); });

    // The sound button. Delegated from the document so it keeps working
    // even if a section is re-rendered in the theme editor.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-vwall-sound]') : null;
      if (!btn) return;
      var video = btn.parentNode.querySelector('[data-vwall-video]');
      if (!video) return;

      e.preventDefault();
      var turningOn = video.muted;

      if (turningOn) {
        videos.forEach(function (other) { if (other !== video) mute(other); });
      }
      video.muted = !turningOn;
      setLabel(btn, turningOn);

      // Asking for sound is also asking to watch it.
      if (turningOn) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    });

    // Muted autoplay while a card is on screen. Skipped when motion is
    // not wanted — the native controls are already there.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.muted) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            video.pause();
            if (!video.muted) mute(video);
          }
        });
      },
      { threshold: 0.35 }
    );
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ----------------------------------------------------------- Boot */

  function boot() {
    initMobileMenu();
    initSearch();
    initStickyHeader();
    initReveals();
    if (!documentBound) {
      initQuantity();
      documentBound = true;
    }
    initBundle();
    initGallery();
    initVariants();
    initBuyBar();
    initCart();
    initMarquee();
    initSocialProof();
    initVideoWall();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run when a merchant edits a section in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
